import React, { AnchorHTMLAttributes } from 'react'

import { overrideOptional } from '@emico/overrides'
import { findActiveStoreView, getStoreViews } from '@emico/storeviews'
import { isExternalUrl } from '@emico/url'

import ExternalLink from './ExternalLink'
import InternalLink from './InternalLink'
import { stripDomainFromUrl } from './stripDomainFromUrl'

export interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Where to link to */
  to: string

  state?: unknown

  // GTM
  /** Tracking event name */
  analyticsName: string
  /** Tracking event category. Use a visual breadcrumb id, e.g. header.subMenu.category */
  analyticsContext: string
}

const Link = ({ to, state, ...props }: Props) => {
  const baseUrl = findActiveStoreView(getStoreViews())?.makeUrl('/')

  // StoreViews are not configured correctly when this happens
  if (!baseUrl) {
    return null
  }

  const isExternal = isExternalUrl(to, baseUrl)

  if (isExternal) {
    return <ExternalLink to={to} {...props} />
  }

  return <InternalLink to={stripDomainFromUrl(to)} state={state} {...props} />
}

export default overrideOptional(Link)
